import { useState } from 'react'
import { IFilteredLactationRoomList } from 'types/LactationType'

export default function useLactationRoomResModal() {
  const [selectedRoom, setSelectedRoom] = useState<IFilteredLactationRoomList>()
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)

  const closeModal = () => setModal(false)
  const openModal = (room?: IFilteredLactationRoomList) => {
    setModal(true)
    if (room) setSelectedRoom(room)
  }

  return {
    selectedRoom,
    setSelectedRoom,
    modal,
    openModal,
    closeModal,
    notification,
    setNotification,
  }
}
